<template>
  <v-list-item
    :href="href"
    :rel="href && href !== '#' ? 'noopener' : undefined"
    :target="href && href !== '#' ? '_blank' : undefined"
    :to="item.to"
    v-if="checkListPermission(item)"
    :active-class="`primary white--text`"
    :title="item.title"
  >
    <v-list-item-icon v-if="item.icon">
      <v-icon v-text="item.icon" />
    </v-list-item-icon>

    <v-list-item-content v-if="item.title">
      <v-list-item-title v-text="item.title" />
    </v-list-item-content>
    <v-list-item-action v-if="item.title == 'Shipments' && shipment > 0">
      <v-chip color="red" small dark>{{ shipment }}</v-chip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { mapState } from "vuex";

export default {
  name: "BaseItem",

  mixins: [Themeable],

  props: {
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        title: undefined,
        to: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    shipment: 0,
  }),
  computed: {
    ...mapState("defaultSystem", ["user"]),
    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
    checkListPermission() {
      return ({ title, meta }) => {
        const site_expired = this.user.site_expired;
        // ========== ========== ========== ==========
        if (title == "OTP Usage") {
          return false;
        } else if (meta?.partner_code == "PM_MARKETING") {
          if (site_expired) return false;
          let check = false;
          if (Array.isArray(this.user?.partner)) {
            const model = this.user.partner.find(
              (x) => x.code == "PM_MARKETING"
            );
            check = model ? true : false;
          }
          return check;
        } else {
          return true;
        }
      };
    },
  },
  created() {
    setTimeout(() => {
      let noti = {};
      try {
        noti = JSON.parse(localStorage.getItem("noti"));
      } catch (err) {
        console.log(err);
      }
      this.shipment = noti?.shipment || 0;
    }, 100);
  },
  methods: {},
};
</script>
